import * as React from 'react';
import { createUseStyles } from 'react-jss';

interface ButtonProps {
    onClick?: () => void;
    href?: string;
    label: string;
    disabled?: boolean;
    className?: string;
}

const useStyles = createUseStyles({
    button: {
        width: '100%',
        paddingBlock: '1px',
        paddingInline: '6px',
        textAlign: 'center',
        border: '2px solid var(--primary-color)',
        color: 'var(--primary-color) !important',
        backgroundColor: 'transparent',
        cursor: 'pointer',
        '&:disabled': {
            border: '2px solid var(--deactivated-color)',
            color: 'var(--deactivated-color)',
            cursor: 'not-allowed',
        }
    },
    link: {
        display: 'inline-block',
        textDecoration: 'none',
        '&:hover': {
            textDecoration: 'none',
        }
    },
});

const Button: React.FC<ButtonProps> = ({ onClick, href, label, className, disabled = false }: ButtonProps) => {
    const classes = useStyles();
    const buttonClass = `${classes.button}${className ? ' ' + className : ''}`;

    if (href) {
        return (
            <a href={href} className={`${buttonClass} ${classes.link}`}>
                {label}
            </a>
        );
    }

    return (
        <button className={buttonClass} onClick={onClick} disabled={disabled}>
            {label}
        </button>
    );
};

export default React.memo(Button);
